import styled from 'styled-components';

export const AuthContainer = styled.div`
  @font-face {
    font-family: "NeuzeitSLTStd-Book";
    src: local("NeuzeitSLTStd-Book") 
          url("../assets/fonts/NeuzeitSLTStd-Book/font.woff2") format("woff2"), 
          url("../assets/fonts/NeuzeitSLTStd-Book/font.woff") format("woff");
  }

  @font-face {
    font-family: "NeuzeitSLTStd-BookHeavy";
    src: local("NeuzeitSLTStd-BookHeavy") 
          url("../assets/fonts/NeuzeitSLTStd-BookHeavy/font.woff2") format("woff2"), 
          url("../assets/fonts/NeuzeitSLTStd-BookHeavy/font.woff") format("woff");
  }

  .info-container {
    margin: 100px auto 0px;
    max-width: 400px;
    font-size: 16px;

    .headline {
      font-family: "NeuzeitSLTStd-BookHeavy",Arial,"sans-serif";
      font-size: 2em;
      line-height: normal;
      font-weight: 600;
      margin-top: 30px;
      margin-bottom: 10px;
      letter-spacing: -0.5px;
    }

    .subheadline {
      line-height: normal;
      font-family: "NeuzeitSLTStd-Book",Arial,"sans-serif";
      font-size: 1.5em;
    }

    h3 {
      margin-top: 30px;
      font-weight: bold;
    }

    li {
      list-style-type: disc;
      p {
          font-size: 18px;
      }
    }
  }

  @media only screen and (max-width: 600px) {
    .info-container {
      font-size: 13px;
      padding: 0px 10px;

      ul li p {
        font-size: 15px;
      }
    }
  }
`;

export const QuantcastLogo = styled.div`
  background-position: center;
  background-size: contain;
  background-image: url("https://static.quantcast.com/images/quantcast-logo-black.svg");
  background-repeat: no-repeat;
  height: 26px;
  width: 148px;
`;

export const FooterHolder = styled.footer`
    background: none repeat scroll 0 0 transparent;
    text-align: center;
    width: 100%;
    height: 20px;
    padding-top: 13px;
    padding-bottom: 30px;
  `;

export const Footer = styled.div`
    margin: auto;
    width: 400px;
  `;

export const FooterLink = styled.span`
    margin: 1em;    
`;

export const BoxCaptcha = styled.div`
    background-color: #fff;
    border-color: #ddd #ddd #d8d8d8;
    box-shadow: 0 2px 0 hsla(0,0%,68.6%,.12);
    overflow: auto;
    border-radius: 3px;
    border-style: solid;
    border-width: 1px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 100px auto 8px;
    width: 400px;
    min-width: 300px;
`;